<template>
  <div class="min-w-screen min-h-screen w-full h-full flex justify-center items-center bg-CLIENT_GR">
    <div class="max-w-7xl bg-white p-8 sm:px-6 lg:px-8 shadow-lg">
      <form
        v-if="!isSend"
        @submit.prevent="updateUserPassword">
        <div>
          <h2 class="mt-10 inline-block text-4xl text-gray-400">パスワードの再設定</h2>
          <div
            class="mt-6">
            <jet-label
              for="email"
              value="登録されているメールアドレス" />
            <jet-input
              id="email"
              v-model="senderEmail"
              type="text"
              class="block mt-1 w-96"
              required
              autofocus />
            <div class="text-right">
              <jet-button
                class="text-sm mt-6 ml-auto">
                パスワード再設定メール送信
              </jet-button>
            </div>
          </div>
        </div>
      </form>

      <div v-if="isSend">
        <h2 class="text-4xl text-center text-red-400 mt-4">送信完了</h2>
        <p class="text-lg text-CLIENT_BL mt-4">ご指定いただいたメールアドレスに再設定用のメールを送信しました。</p>
        <a
          class="block w-40 border border-black text-center py-2 px-4 rounded-full mx-auto mt-6 transition hover:bg-black hover:text-white"
          href="/login">
          ログインページへ
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import { reactive, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { EmailRegex } from '@/Constants/regularExpression'
import AppClientLayout from '@/Layouts/AppClientLayout'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'
import firebaseApp from '@/Constants/configFirebase'

const senderEmail = ref('')
const errorMessage = ref('')
const isSend = ref(false)
const auth = getAuth(firebaseApp)

const actionCodeSettings = {
  // 環境変数の値を読み込む
  url: route('clients.login.index'),
}

const updateUserPassword = () => {
  // eslint-disable-next-line no-console
  if (!senderEmail.value.match(EmailRegex)) {
    errorMessage.value = '登録されているメールアドレスを正しく入力してください。'
    return false
  }
  sendPasswordResetEmail(auth, senderEmail.value, actionCodeSettings).then(() => {
    isSend.value = true
  }).catch((e) => {
    // eslint-disable-next-line no-alert
    alert(e.code)
    return false
  })
  return undefined
}
</script>
